import React, { useState } from 'react';
const faqs = [{
  q: '¿Es apto para entrenadores principiantes?',
  a: 'Absolutamente. Fútbol Listo 360 fue diseñado para entrenadores de todos los niveles — desde el primer año hasta entrenadores con experiencia. Todo está explicado paso a paso con diagramas para que puedas usarlo desde el primer día.'
}, {
  q: '¿Qué categorías de edad cubre?',
  a: 'El programa cubre todas las categorías juveniles desde U8 hasta U17 con tres volúmenes dedicados, más preparación física y contenido técnico que aplica a todas las edades.'
}, {
  q: '¿Es un producto físico o digital?',
  a: 'Es 100% digital. Después de tu compra recibes acceso inmediato para descargar todos los PDFs directamente en tu dispositivo.'
}, {
  q: '¿Cómo recibo mi compra?',
  a: 'Inmediatamente después del pago recibes un email con tu enlace de descarga. Puedes acceder a tus archivos en minutos desde cualquier lugar del mundo.'
}, {
  q: '¿Qué pasa si no estoy satisfecho?',
  a: 'Ofrecemos una garantía total de 7 días. Si no estás completamente satisfecho por cualquier motivo, contáctanos y te devolvemos tu dinero sin preguntas.'
}, {
  q: '¿Puedo usarlo para entrenar en un colegio o escuela?',
  a: 'Sí. El contenido está perfectamente estructurado para entornos escolares y clubes. Las sesiones funcionan con grupos grandes, requieren equipamiento mínimo y siguen progresiones curriculares estándar.'
}, {
  q: '¿En qué se diferencia de los recursos gratuitos que encuentro online?',
  a: 'Los recursos gratuitos te dan ejercicios sueltos o sesiones aisladas. Fútbol Listo 360 te da un sistema completo — 150+ sesiones organizadas por categoría de edad, calendario de planificación anual, cuaderno táctico, herramientas de evaluación y 5 bonos. Todo conectado, estructurado y listo para usar en menos de 5 minutos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-30">
          Preguntas <span className="text-[#00A650]" data-id="element-31">Frecuentes</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-32">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-33">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-34">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-35">
                    {faq.q}
                  </span>
                  <span className={`text-[#00A650] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-36">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-37">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-38">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}